import {Directive, ElementRef, HostBinding, HostListener} from '@angular/core';

@Directive({
  selector: '[appDropdown]'
})
export class DropdownDirective {
  @HostBinding('class.open') open;

  constructor(private elemRef: ElementRef) { }
  @HostListener('click')
  onDropDownClick() {
    this.open = !this.open;
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.elemRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/shared/search-dropdown/dropdown.directive.ts